import { IAriaLabels } from '@models/IAriaLabels';
import useAriaLabelsStore from '@state/AriaLabelsStore';
import useSoftLoadStore from '@state/SoftLoadStore';
import { useEffect } from 'react';

interface Props {
  readonly accessibility: IAriaLabels;
}

// This component is added to every page, this component is handy for dispatching global state and avoid prop drilling
const GlobalSettings = ({ accessibility }: Props) => {
  const { setAriaLabels } = useAriaLabelsStore((state) => ({
    setAriaLabels: state.setAriaLabels,
  }));
  const { setIsSoftLoadEnabled } = useSoftLoadStore((state) => ({
    setIsSoftLoadEnabled: state.setIsSoftLoadEnabled,
  }));

  useEffect(() => {
    setAriaLabels(accessibility);
  }, [accessibility, setAriaLabels]);

  useEffect(() => {
    setIsSoftLoadEnabled(
      document.body.getAttribute('data-enable-soft-load') === 'True'
    );
  }, [setIsSoftLoadEnabled]);

  return null;
};

export default GlobalSettings;
